export default {
	data() {
		return {
			mobileBankTabOS: 'ios',
			mobileBankTabFooter: 'reg'
		}
	},
}
